import React from 'react';
import './AuthButton.css';
import InstagramLogo from '../../assets/icons/instagram_logo.svg';
import TiktokLogo from '../../assets/icons/tiktok_logo.svg';
import AppleLogo from '../../assets/icons/apple_logo.svg';

interface AuthButtonProps {
  provider: 'Instagram' | 'Tiktok' | 'Apple' | 'Email';
  action: 'signin' | 'signup';
  onSignIn: () => void;
  onSignUp: () => void;
}

const AuthButton: React.FC<AuthButtonProps> = ({ provider, action, onSignIn, onSignUp }) => {
  const getIcon = () => {
    switch (provider) {
      case 'Instagram':
        return <img src={InstagramLogo} alt="Instagram Logo" className="auth-icon" />;
      case 'Tiktok':
        return <img src={TiktokLogo} alt="TikTok Logo" className="auth-icon" />;
      case 'Apple':
        return <img src={AppleLogo} alt="Apple Logo" className="auth-icon" />;
      default:
        return null;
    }
  };

  const buttonText = action === 'signin' ? `Sign in with ${provider}` : `Continue with ${provider}`;
  const handleClick = action === 'signin' ? onSignIn : onSignUp;

  return (
    <button onClick={handleClick} className="auth-button">
      <span>{getIcon()}</span>
      <span>{buttonText}</span>
    </button>
  );
};

export default AuthButton;
